module.exports = __webpack_public_path__ + "static/media/hp.77cfbd19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeView/logos/hp.svg
// module id = 342
// module chunks = 0